import Link from 'next/link';

import type DealerType from '../../types/DealerType';

import styles from './DealerResult.module.scss';

interface Props {
  dealer: DealerType;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const DealerResult: React.FC<Props> = ({
  dealer,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <Link href={`/dystrybutorzy/${dealer.slug}`}>
      <a
        className={styles.dealerResult}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div className={styles.dealerName}>{dealer.name}</div>
        <div className={styles.dealerAddress}>{dealer.address}</div>
      </a>
    </Link>
  );
};
export default DealerResult;
